import { FloatingDelayGroup } from '@floating-ui/react';
import React, { HTMLAttributes } from 'react';

export interface VoxelTableRowProps
  extends Pick<
    HTMLAttributes<HTMLTableRowElement>,
    'onClick' | 'onMouseDown' | 'onMouseUp' | 'onMouseOver' | 'onMouseEnter' | 'onMouseLeave'
  > {
  disabled?: boolean;
  className?: string;
  button?: boolean;
  selected?: boolean;
}

export const VoxelTableRow: React.FC<VoxelTableRowProps> = ({
  children,
  onClick,
  onMouseDown,
  onMouseUp,
  onMouseOver,
  disabled,
  className,
  button = false,
  selected = false,
  ...tableProps
}) => {
  return (
    <FloatingDelayGroup delay={{ open: 700, close: 300 }}>
      <tr
        className={`
        border-b border-voxel-gray-200/50 ${className} 
        ${
          button &&
          `relative
            group
            cursor-pointer
            hover:bg-gray-100
          `
        }
          ${selected && 'bg-gray-50 hover:bg-gray-100'}
          `}
        onClick={disabled ? () => {} : onClick}
        {...tableProps}
      >
        {children}
      </tr>
    </FloatingDelayGroup>
  );
};

export default VoxelTableRow;
